import { Dictionary } from '@summer/react-kit/dictionaries/types';
import { BaseAxios, flatten } from 'core/axios/axios';

const fetch = (): Promise<Dictionary> => {
  return BaseAxios.get<Dictionary>('api/dictionary/list').then(flatten);
};

export const DictionaryService = {
  fetch,
};
